import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getPaymentSettings, updatePaymentSettings } from '@/backend/services/paymentSettings';
import type { PaymentSettings } from '@/backend/services/paymentSettings';

export function usePaymentSettings() {
  return useQuery({
    queryKey: ['payment-settings'],
    queryFn: getPaymentSettings,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdatePaymentSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data, updatedBy }: { data: Partial<PaymentSettings>; updatedBy: string }) =>
      updatePaymentSettings(data, updatedBy),
    onSuccess: (_, { data }) => {
      queryClient.setQueryData<PaymentSettings>(['payment-settings'], (old) =>
        old ? { ...old, ...data } : (data as PaymentSettings),
      );
      queryClient.invalidateQueries({ queryKey: ['payment-settings'] });
    },
  });
}
